/* eslint-disable react-hooks/rules-of-hooks */
import * as React from 'react';
import { useIsomorphicLayoutEffect } from '@cian/react-utils';
import { DeviceTypeMediaQuery } from '../../../internal/services';
import { useUiKitContext } from '../../../internal/context';

/**
 * Возвращает deviceType, используемый в Ui-Kit
 *
 * На сервере возвращает deviceType из контекста Ui-Kit
 *
 * Если в контексте стоит флаг useStaticDeviceType то всегда возвращает deviceType из контекста
 */
export function useDeviceType() {
  const {
    deviceType: staticDeviceType,
    useStaticDeviceType
  } = useUiKitContext();
  if (typeof window === 'undefined') {
    return staticDeviceType;
  }
  const mediaQuery = DeviceTypeMediaQuery.ensureSingleton();
  const [deviceType, setDeviceType] = React.useState(staticDeviceType);
  useIsomorphicLayoutEffect(() => {
    if (useStaticDeviceType) {
      if (deviceType !== staticDeviceType) {
        setDeviceType(staticDeviceType);
      }
    } else {
      const mediaDeviceType = mediaQuery.getDeviceType();
      if (mediaDeviceType && deviceType !== mediaDeviceType) {
        setDeviceType(mediaDeviceType);
      }
    }
  }, [useStaticDeviceType, staticDeviceType]);
  React.useEffect(() => {
    if (useStaticDeviceType) {
      return;
    }
    return mediaQuery.subscribe(value => setDeviceType(value || staticDeviceType));
  }, [mediaQuery, staticDeviceType, useStaticDeviceType]);
  return deviceType;
}